export class BaseTool {
  constructor(id) {
    this.id = id;
  }

  onPointerDown() {}

  onPointerMove() {}

  onPointerUp() {}

  cancel() {}
}
